// Supported plugins configuration
GLOBAL.config = {

  // Replace checkboxes and radio buttons
  inputs: $('[type="checkbox"]'),

  // Replace selectors
  selectors: $(),

  // Carousels
  carousels: {
    /*'#main': {
      wrap: false,
      vertical: false,
      method: 'scroll',
      scrollableItems: 1,
      autoscrollInterval: 10000, // ms
      pagination: true,
      touchable: GLOBAL.isTouchscreen
    }*/
  },

  // Modal windows
  modals: {
    /*'.presentation': {
      node: '#presentation',
      fixedElements: 'header',
      onHide: function () {
        $.overlayLoader(true, {
          node: $('#presentation-success')
        });
      }
    }*/
  },

  // Popups
  popups: {
    '.recall': {
      rel: '#recall',
      posTop: {
        value: 'center - (%%TARGETHEIGHT%% / 2)',
        auto: '%%DOCUMENTHEIGHT%%'
      },
      posLeft: {
        value: 'before - 30',
        auto: '(%%WINDOWWIDTH%% / 2) - (%%TARGETWIDTH%% / 2)'
      },
      effect: 'fast',
      onShow: function (source, target) {
        var tt = parseFloat($(target).css('top'));
        if (tt >= $('footer').position().top) {
          if ($(source).hasClass('popup-activator-top')) {
            $(target).css('top', $(document).scrollTop());
          } else {
            $(target).css('top', $(document).scrollTop() + $(window).height() - $(target).height());
          }
        }
        $(source).addClass('active');
      },
      onHide: function (source, target) {
        $(source).removeClass('active');
      }
    }
  },

  // Tabs
  tabs: {
    '#showcase': {
      updateHash: false
    }
  }

};